const normalise = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()

// Order responses come from more than one endpoint. Keep quote detection
// independent of a single response-field naming convention so a quote can
// never be treated as a completed sale.
export const isQuoteRequest = (order = {}) => {
  const orderValues = [
    order.payment_method,
    order.paymentMethod,
    order.payment_method_id,
    order.paymentMethodId,
    order.payment_method_title,
    order.paymentMethodTitle,
    order.status,
    order.order_status,
    order.orderStatus,
  ].map(normalise)

  return orderValues.some(
    (value) =>
      value === "quoterequest" ||
      value === "quote" ||
      value === "quote_request" ||
      value === "quote-request" ||
      value === "request a quote"
  )
}

const toAmount = (value) => {
  const amount = Number(value)
  return Number.isFinite(amount) ? amount : 0
}

// Track merchandise revenue only. WooCommerce's order total also includes
// shipping and tax, which makes analytics revenue differ from net revenue.
export const getProductRevenue = (order) =>
  (order?.line_items || []).reduce((total, item) => {
    const lineTotal = Number(item?.line_total)

    if (
      item?.line_total !== null &&
      item?.line_total !== undefined &&
      Number.isFinite(lineTotal)
    ) {
      return total + lineTotal
    }

    return (
      total +
      toAmount(item?.unit_price ?? item?.price) * toAmount(item?.quantity)
    )
  }, 0)
